export default __webpack_public_path__ + "static/media/Force0.1434ba81.png";